import { categoryConstants } from '../constants';

export function category(state = {}, action) {
  switch (action.type) {
    case categoryConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case categoryConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        loading: false
      }
    case categoryConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    default:
      return state;
  }
}

export function createCategory(state = {}, action) {
  switch (action.type) {
    case categoryConstants.CREATE_REQUEST:
      return {
        state,
        loading: true
      }
    case categoryConstants.CREATE_SUCCESS:
      return {
        ...state,
        tokenID: action.tokenID,
        loading: false
      }
    case categoryConstants.CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    default:
      return state;
  }
}

export function getCategory(state = {}, action) {
  switch (action.type) {
    case categoryConstants.GET_REQUEST:
      return {
        state,
        loading: true
      }
    case categoryConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case categoryConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    default:
      return state;
  }
}

export function updateCategory(state = {}, action) {
  switch (action.type) {
    case categoryConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true
      }
    case categoryConstants.UPDATE_SUCCESS:
      return {
        ...state,
        tokenID: action.tokenID,
        loading: false
      }
    case categoryConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    default:
      return state;
  }
}

export function deleteCategory(state = {}, action) {
  switch (action.type) {
    case categoryConstants.DELETE_REQUEST:
      return {
        state,
        loading: true
      }
    case categoryConstants.DELETE_SUCCESS:
      return {
        ...state,
        tokenID: action.tokenID,
        loading: false
      }
    case categoryConstants.DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    default:
      return state;
  }
}